<template>
    <modal name="deleteLlmSkillModal" :width="400" :height="400" :adaptive="true">
        <div class="modal-content modal-default">
            <h3>
                Are you sure you want to delete this LLM skill?
            </h3>
            <button @click="deleteLlmSkill">Yes</button>
            <button @click="closeModal">No</button>
        </div>
    </modal>
</template>
<script>
import api from "../../services/api";
import { utilFunctionService } from "../../utils/utils.service";
export default {
    name: 'DeleteLlmSkillModal', 
    props: {
        llm_skill_id: {
            type: Number,
            required: true
        }
    },
    methods: {
        closeModal() {
            this.$modal.hide('deleteLlmSkillModal')
        },
        deleteLlmSkill() {
            utilFunctionService.showLoader();
            let payload = {
                id: this.llm_skill_id
            }
            api.deleteLlmSkill(payload, this).then((response) => {
                this.llm_skills = response.data;
                this.$router.push("/llm-skills");
                utilFunctionService.hideLoader();
            })
        }
    }
}
</script>
<style lang="scss">
</style>